import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DockMonitorModule } from './src/dock-monitor/index';
import { LogMonitorModule } from './src/log-monitor/index';
import { StoreLogMonitorComponent } from './src/store-log-monitor';
export var StoreLogMonitorModule = (function () {
    function StoreLogMonitorModule() {
    }
    StoreLogMonitorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        DockMonitorModule,
                        LogMonitorModule
                    ],
                    declarations: [
                        StoreLogMonitorComponent
                    ],
                    exports: [
                        StoreLogMonitorComponent
                    ]
                },] },
    ];
    /** @nocollapse */
    StoreLogMonitorModule.ctorParameters = [];
    return StoreLogMonitorModule;
}());
export { useDockMonitor as useLogMonitor } from './src/dock-monitor/index';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/store-log-monitor/index.js
// module id = cWuS
// module chunks = 4